import type { WebsiteUrlRule } from '@/types/websiteUrlRule';

export const sanitizeWebsiteUrlRules = (rules?: WebsiteUrlRule[]) => {
  if (!Array.isArray(rules)) return rules;

  return rules.map(rule => ({
    url: rule.url,
    operator: rule.operator,
    count: rule.count,
    ...(rule.target_page_id ? { target_page_id: rule.target_page_id } : {}),
    ...(rule.time_spent_operator ? { time_spent_operator: rule.time_spent_operator } : {}),
    ...(rule.time_spent_seconds !== undefined
      ? { time_spent_seconds: rule.time_spent_seconds }
      : {}),
  }));
};
